import * as React from "react";
import styled from "styled-components";

export default function App() {
  return (
    <div>
      <Shortcuts>
        <ShortcutItem href="http:/www.google.com">Google Search</ShortcutItem>
        <ShortcutItem href="http:/www.nhl.com">NHL</ShortcutItem>
        <ShortcutItem href="http:/www.androidpolice.com">
          Android Police
        </ShortcutItem>
        <ShortcutItem href="http:/www.cnn.com">CNN</ShortcutItem>
        <ShortcutItem href="http:/www.bbc.co.uk/news">BBC News</ShortcutItem>
        <ShortcutItem newWindow href="http://www.gp.se">
          GP.se
        </ShortcutItem>
      </Shortcuts>
    </div>
  );
}

const ShortcutGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 160px);
  grid-column-gap: 4px;
  grid-row-gap: 4px;
`;

type StyledShortcutProps = {
  newWindow: boolean;
};
const StyledShortcut = styled.a<StyledShortcutProps>`
  display: flex;
  width: 148px; //change to dynamic
  height: 148px; //change to dynamic
  color: green;
  border: 4px solid ${(props) => (props.newWindow ? "blue" : "red")};
  text-decoration: none;
  font-size: 18px;
  padding: 2px;
  justify-content: center;
  span {
    align-self: flex-end;
  }
`;

type ShortcutItemProps = {
  href: string;
  children: React.ReactNode;
  newWindow?: boolean;
};
const ShortcutItem = ({ href, children, newWindow }: ShortcutItemProps) => (
  <StyledShortcut
    target={newWindow ? "_blank" : ""}
    rel={newWindow ? "noreferrer noopener" : ""}
    href={href}
    newWindow={newWindow ?? false}
  >
    <span>{children}</span>
  </StyledShortcut>
);

type ShortcutsProps = {
  children: React.ReactNode;
};

const Shortcuts = ({ children }: ShortcutsProps) => {
  return <ShortcutGrid>{children}</ShortcutGrid>;
};
